'use strict';

/**
 * T451 P3.4b — the PURE half of washdown-template.js: template JSON →
 * createRoutine-shaped params. No filesystem, no node builtins, so the vault
 * bundle can ship it and the routines view can instantiate the Washdown
 * routine in the page under TASKS_BROWSER_DECRYPT (the template itself is not
 * user content and still comes from GET /api/tasks/washdown-template; what
 * retires is the server-side POST /api/tasks/routine that opened the store
 * under the warm key). washdown-template.js#buildWashdownRoutineParams
 * delegates here, so the server and the browser build the SAME params from
 * the SAME template — pinned by P2 of
 * __tests__/tasks/t451-p3-4b-sibling-views-sealed-write-v1.test.js.
 */

function routineParamsFromTemplate(tpl, opts) {
  const t = tpl && typeof tpl === 'object' ? tpl : {};
  const o = opts || {};
  const rounds = (Array.isArray(t.rounds) ? t.rounds : []).map((r) => ({
    title: r.title,
    targetCount: r.targetCount || null,
    description: r.description || '',
  }));
  const params = {
    name: t.name || 'Washdown Routine',
    description: t.description || '',
    rounds,
  };
  if (o.listId) params.listId = o.listId;
  if (o.listName) params.listName = o.listName;
  return params;
}

module.exports = { routineParamsFromTemplate };
